function slugify(text) {
  return text.replace(/\s/g, '-').replace(/--/g, '-').replace(/^-/, '').replace(/-$/, '').toLowerCase();
}
export default slugify;